import { render } from "./Artboard_AlbumOfTheMonth.vue?vue&type=template&id=47f96ebc&scoped=true"
import script from "./Artboard_AlbumOfTheMonth.vue?vue&type=script&lang=js"
export * from "./Artboard_AlbumOfTheMonth.vue?vue&type=script&lang=js"

import "./Artboard_AlbumOfTheMonth.vue?vue&type=style&index=0&id=47f96ebc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47f96ebc"

export default script